import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheContainer = _resolveComponent("TheContainer")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_WafDialogWrapper = _resolveComponent("WafDialogWrapper")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _component_NotificationDialog = _resolveComponent("NotificationDialog")!
  const _component_LoginDialog = _resolveComponent("LoginDialog")!
  const _component_ProfileDialog = _resolveComponent("ProfileDialog")!
  const _component_CookiesAcceptModal = _resolveComponent("CookiesAcceptModal")!
  const _component_q_no_ssr = _resolveComponent("q-no-ssr")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_layout, { view: "hHh Lpr fff" }, {
      default: _withCtx(() => [
        _createVNode(_component_TheHeader),
        _createVNode(_component_TheContainer),
        (!_ctx.hideFooter)
          ? (_openBlock(), _createBlock(_component_TheFooter, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_WafDialogWrapper)
      ]),
      _: 1
    }),
    _createVNode(_component_NotificationDialog, { "with-footer": false }),
    _createVNode(_component_LoginDialog),
    _createVNode(_component_ProfileDialog),
    _createVNode(_component_q_no_ssr, null, {
      default: _withCtx(() => [
        _createVNode(_component_CookiesAcceptModal)
      ]),
      _: 1
    })
  ], 64))
}